<template>
    <dtunes-modal :dialog="dialog" @openModal = "dialog = true" @closeModal = "dialog = false">
    <template v-slot:button> edit </template>
    <template v-slot:content>
      <v-card flat class="dt-border pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">Edit {{ details.name }} STORE</p>
        </v-card-title>
        <v-card-text>
          <v-text-field
            style="border-color: red"
            color="auto"
            label="Name"
            outlined
            v-model="cardName"
          ></v-text-field>
          <v-row align="center" justify="center">
              <v-col align="center" justify="center">
                  <v-img height="100" width="100" style="border-radius:10px" :src="details.icon" />
                  <p><b>Current Icon</b></p>
              </v-col>
              <v-col align="center" justify="center">
                  <v-img height="100" width="100" style="border-radius:10px" :src="details.logo" />
                  <p><b>Current Logo</b></p>
              </v-col>
          </v-row>
          
          <v-file-input
            accept="image/*"
            placeholder="Edit Logo"
            prepend-icon="mdi-camera"
            outlined
            v-model="Logo"
            id="logo"
            color="auto"
            ref="storeImage"
            label="Edit Logo"
          ></v-file-input>
          <v-file-input
            accept="image/*"
            placeholder="Edit Icon"
            prepend-icon="mdi-camera"
            outlined
            id="icon"
            v-model="Icon"
            ref="storeImage"
            label="Edit Icon"
          ></v-file-input>
          <br />
          <default-button :loading="loading" :disabled=false @click="editStore">Edit Store</default-button>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// =============== IMPORT COMPONENT ==============
import DefaultButton from "@/components/Buttons/default-button.vue";
import DtunesModal from "@/components/dtunes-modal.vue";

// ============== IMPORT SERVICES ===========
import * as storageService from "@/utils/firebase/storage";
import { StoresService } from "@/services";

export default {
    components:{
        DefaultButton,
        DtunesModal
    },
    props:{
        details:{
            type: Object,
            required: true
        },
    },
    data: () => ({
        fileName:[],
        cardName : '',
        icon : '',
        logo : '',
        Logo:[],
        Icon:[],
        tmStamp: '',
        dialog:false,
        loading: false,
    }),
    mounted(){
        this.cardName = this.details.name,
        this.icon = this.details.icon,
        this.logo = this.details.logo
    },
    computed:{
        
    },
    methods:{
        async uploadImage(location,picture) {
            let date = Date.now()
            let file = this[location];
            let path = `/giftcard/stores/${location}`;
            let pixName = this.cardName + '-'+ date.toString();
            let image = await storageService.uploadImages(path, pixName, file);
            this[picture] = image; 
        },

        async uploadArtifacts() {
            if(this.Logo.length != 0){
                await this.uploadImage('Logo','logo');
            }
            if(this.Icon.length != 0){
                await this.uploadImage('Icon','icon');
            }
        },
        async editStore(){
            try {
                this.loading = true
                await this.uploadArtifacts();
                const data = await StoresService.editStores({
                    id : this.details.id,
                    name: this.cardName,
                    icon:this.icon,
                    logo : this.logo
                });
                this.loading = false;
                this.$store.dispatch('toast', {
                    message: ` ${this.details.name} store edited sucessfully`,
                    variant: 'success'
                });
                console.log(data);
                this.Logo = [],
                this.Icon = [],
                this.dialog = false;
                this.$emit('closeModal')
            } catch (error) {
                this.loading = false
                console.log(error);
            }
        },
    }
}
</script>
